import { makeAxiosHttpClient } from 'src/main/factories/http/axios-http-client-factory-no-redirect'
import { PollingTaskStatus } from 'src/main/store-models/polling-status/types'

export const checkApuracaoStatus = async (jobId: string): Promise<PollingTaskStatus> => {
  const httpClient = makeAxiosHttpClient()
  const { statusCode, body } = await httpClient.request({
    url: `/apuracao/status/${jobId}`,
    method: 'get',
  })

  if (statusCode !== 200) throw new Error('Erro ao verificar status da apuração')

  const {
    status, errorMessage, progress, iniciadoEm, finalizadoEm,
  } = body as {
    status: string
    errorMessage?: string
    progress?: number | null
    iniciadoEm?: string | null
    finalizadoEm?: string | null
  }

  if (status === 'CONCLUIDO') {
    const meta: Record<string, string> = {}
    if (iniciadoEm) meta.iniciadoEm = iniciadoEm
    if (finalizadoEm) meta.finalizadoEm = finalizadoEm
    return { status: 'success', message: 'Apuração concluída com sucesso', meta }
  }

  if (status === 'ERRO') {
    const meta: Record<string, string> = {}
    if (iniciadoEm) meta.iniciadoEm = iniciadoEm
    meta.finalizadoEm = new Date().toISOString()
    return {
      status: 'error',
      message: 'Erro na apuração',
      errors: errorMessage ? [errorMessage] : ['Ocorreu um erro ao gerar a apuração'],
      meta,
    }
  }

  const meta: Record<string, string> = {}
  if (progress != null) meta.Progresso = `${progress}%`
  if (iniciadoEm) meta.iniciadoEm = iniciadoEm

  return {
    status: 'loading',
    message: status === 'AGUARDANDO' ? 'Aguardando processamento' : 'Processando apuração',
    meta,
  }
}
